const Design = () => {
  return (
    <>
      <ul
        className='illustration'
        style={{ display: 'flex', flexWrap: 'wrap' }}
      ></ul>
    </>
  );
};
export default Design;
